<template>
  <div class="custom-table">
    <div class="search-div">
      <div v-if="searchable && searchPlace === 'top'" style="display: flex;align-items: center;width: 60%;" class="search-con search-con-top" ref="searchConTop">
        <Select v-model="searchKey" class="search-col" style=" margin-right: 2%;width: 25%;" :disabled="showPanel" @on-change="changeSearchKey">
          <Option v-for="item in searchColumns" :disabled="isAddedKeys.indexOf(item.key) !== -1" v-if="item.key !== 'handle'&&item.key !== 'index' && item.key !== 'action' && !item.disable" :value="item.key" :key="`search-col-${item.key}`">{{ item.title }}</Option>
        </Select>
        <!--时间查询-->
        <DatePicker
          class="search-input"
          @on-change="handleDateChange"
          format="yyyy-MM-dd HH:mm:ss"
          clearable
          split-panels
          transfer
          :value="addColumns[0].value"
          ref="topDatePicker"
          v-if="addColumns[0] && addColumns[0].type == 'time'"
          type="datetimerange"
          :placeholder="$t('searchTime')"
        ></DatePicker>
 <!--文本查询-->
        <Input v-if="addColumns[0] && addColumns[0].type == 'text'" clearable :placeholder="$t('searchTip')" class="search-input" v-model="addColumns[0].value"/>
        <!--大小的查询-->
        <Select v-model="addColumns[0].compare" v-if="addColumns[0] && addColumns[0].type == 'compare'" clearable class="search-compare">
          <Option v-for="item in compareList" :value="item.id" :key="`search-col-${item.id}`">{{ item.name }}</Option>
        </Select>
        <Input v-if="addColumns[0] && addColumns[0].type == 'compare'" clearable :placeholder="$t('searchTip')" class="search-compare-input" v-model="addColumns[0].value"/>
        <!--下拉框查询-->
        <Select v-model="addColumns[0].value" v-if="addColumns[0] && addColumns[0].type == 'select'" clearable class="search-select">
          <Option v-for="item in addColumns[0].list" :value="item.id" :key="`search-col-${item.id}`">{{ item.name }}</Option>
        </Select>
        <Button @click="handleSearch" class="search-btn" type="info" size="small" ghost ><Icon type="md-search" />&nbsp;&nbsp;{{$t('search')}}</Button>
        <div style="
        margin-left: 0.25rem;
        width: 0.25rem;
        height: 0.25rem;overflow: hidden;"  @click="showTablePanel">
          <img class="more_icon" v-if="!showPanel" :src="closeSearch">
          <img class="more_icon" v-else :src="openSearch">
        </div>
      </div>
      <div class="export-cons">

      <!--导出，导入-->
      <div v-if="exportable && exportPlace === 'top'" class="export-con">
        <Button v-show="hasExportFileRole" class="search-btn broad-top-button" ghost type="success" :loading="exportLoading" @click="exportExcel" style="margin-right: 2px;">{{$t('exportFile')}}</Button>
        <Upload action="//" :before-upload="handleUpload"  :format="['xls','xlsx']" :on-format-error="handleFormatError" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :max-size="10240" :on-exceeded-size="handleMaxSize">
          <Button v-show="hasImportFileRole" type="success" class="search-btn broad-top-button" ghost>{{$t('importFile')}}</Button>
        </Upload>
      </div>

      <!--自定义插槽按钮-->
      <div class="export-con">
        <slot name="button">
        </slot>
      </div>

      </div>

    </div>
    <div class="search-table" v-if="showPanel" :style="searchStyle">
      <div class="column-main">
        <div class="foreach-column" v-for="(itemOne,index) in addColumns">
          <Select :disabled="index == 0" v-model="itemOne.key" style="width: 27%;margin-right: 2%;" @on-change="changePanelKey(itemOne,index)">
            <Option v-for="item in searchColumns" :disabled="isAddedKeys.indexOf(item.key) !== -1" v-if="item.key !== 'handle'&&item.key !== 'index' && item.key !== 'action' && !item.disable" :value="item.key" :key="`search-col-${item.key}`">{{ item.title }}</Option>
          </Select>
          <DatePicker style="width: 64%;"   @on-change="(val, type) => handlePanelDateChange(itemOne, val, type)"   format="yyyy-MM-dd HH:mm:ss"
                      class="search-input" clearable split-panels transfer ref="DatePicker" :value="itemOne.value" v-if="itemOne.type=='time'" type="datetimerange" :placeholder="$t('searchTime')"  ></DatePicker>

        <Input style="width: 64%;" v-if="itemOne.type=='text'" clearable :placeholder="$t('searchTip')" class="search-input" v-model="itemOne.value"/>

          <Select v-model="itemOne.compare" v-if="itemOne.type=='compare'" clearable class="search-compare">
            <Option v-for="item in compareList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
          <Input v-if="itemOne.type=='compare'" @on-change="handleClear" clearable :placeholder="$t('searchTip')" class="search-compare-input" v-model="itemOne.value"/>

          <!--下拉框查询-->
          <Select style="width: 64%;margin-left: 2px;" v-model="itemOne.value" v-if="itemOne.type=='select'" clearable class="search-col">
            <Option v-for="item in itemOne.list" :value="item.id" :key="`search-col-${item.id}`">{{ item.name }}</Option>
          </Select>

          <Icon class="close-icon" style="color:#00d5ff;" v-if="index == 0" @click="closeSearchPanel" type="ios-arrow-up"/>
<!--          <Icon class="delete-icon" style="color:#00d5ff;"  v-else type="ios-close" @click="deleteColumn(index)" />-->
          <el-button v-else class="delete-icon" type="text" icon="el-icon-delete" size="mini" @click="deleteColumn(index)"></el-button>
        </div>
      </div>
      <div class="footer-add">
        <Icon type="ios-add-circle-outline" class="add-icon" style="color:#00d5ff;"  @click="addDataToSearch"/>
<!--        <svg-icon iconClass="delete_icon"  class="add-icon" style="color:#00d5ff;"  @click.native="addDataToSearch"/>-->

      </div>
    </div>
    <div v-if="pageable && pagePlace === 'top'" class="page-con">
      <Page :total="total" size="small" :page-size='pageLimit' :current='current' :page-size-opts="pageSizeList" :transfer="true" show-total show-sizer  @on-change="pageChange" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;" class="jump-where">{{$t('jump_to')}}</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage" @keyup.enter.native="handleCurrentPage"/><div style="padding-top: 2px;" class="jump-where">{{$t('page')}}</div>
    </div>

    <Table
      ref="tablesMain"
      :data="insideTableData"
      :columns="insideColumns"
      :stripe="stripe"
      :border="border"
      :show-header="showHeader"
      :width="width"
      :height="height"
      :loading="loading"
      :disabled-hover="disabledHover"
      :highlight-row="highlightRow"
      :row-class-name="rowClassName"
      :size="size"
      :no-data-text="noDataText"
      :no-filtered-data-text="noFilteredDataText"
      @on-current-change="onCurrentChange"
      @on-select="onSelect"
      @on-select-cancel="onSelectCancel"
      @on-select-all="onSelectAll"
      @on-select-all-cancel="onSelectAllCancel"
      @on-selection-change="onSelectionChange"
      @on-sort-change="onSortChange"
      @on-filter-change="onFilterChange"
      @on-row-click="onRowClick"
      @on-row-dblclick="onRowDblclick"
      @on-cell-click="onCellClick"
      @on-expand="onExpand"
    >
      <slot name="header" slot="header"></slot>
      <slot name="footer" slot="footer"></slot>
      <slot name="loading" slot="loading"></slot>
    </Table>
    <div v-if="searchable && searchPlace === 'bottom'" class="search-con search-con-top">
      <Select v-model="searchKey" class="search-col" @on-change="changeSearchKey">
        <Option v-for="item in columns" v-if="item.key !== 'handle' && item.key !== 'action' && !item.disable" :value="item.key" :key="`search-col-${item.key}`">{{ item.title }}</Option>
      </Select>
      <DatePicker class="search-input" @on-clear="handleClear2" clearable split-panels v-model="searchTime" v-if="showTime" type="datetimerange"  :placeholder="$t('searchTime')"  ></DatePicker>
      <Input v-if="!showTime" @on-change="handleClear" clearable :placeholder="$t('searchTip')" class="search-input" v-model="searchValue"/>
      <Button @click="handleSearch" class="search-btn" type="primary"><Icon type="md-search" />&nbsp;&nbsp;{{$t('search')}}</Button>
    </div>
    <div v-if="pageable && pagePlace === 'bottom'" class="page_style">
      <a id="hrefToExportTable" class="table-export-template-link" href="#" @click.prevent="downTemplate" v-show="downTemp && hasImportFileRole">{{$t('exportTemp')}}</a>
      <Page :total="dataTotal" size="small" :page-size='pageLimit' :current='current' :page-size-opts="pageSizeList" :transfer="true" placement="top" show-total show-sizer  @on-change="pageChange"  @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;" class="jump-where">{{$t('jump_to')}}</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage" @keyup.enter.native="handleCurrentPage"/><div style="padding-top: 2px;" class="jump-where">{{$t('page')}}</div>
    </div>
    <a v-else id="hrefToExportTable" class="table-export-template-link" href="#" @click.prevent="downTemplate" v-show="downTemp && hasImportFileRole">{{$t('exportTemp')}}</a>
  </div>
</template>

<script>
import TablesEdit from './edit.vue'
import handleBtns from './handle-btns'
import {Button} from 'element-ui'
import closeSearch from '@/assets/images/closeSearch.png'
import closeSearchWhite from '@/assets/images/closeSearchWhite.png'
import openSearch from '@/assets/images/openSearch.png'
import openSearchWhite from '@/assets/images/openSearchWhite.png'
import {publicFunClass} from '@/libs/PublicFunClass.js'
import {isNumber} from '@/libs/tools'
import {forEach} from "../../libs/tools";
//import './index.less'
export default {
  name: 'Tables',
  mixins:[publicFunClass],
  components: { 'el-button': Button },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    searchColumns:{
      type: Array,
      default () {
        return []
      }
    },
    size: String,
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    stripe: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    highlightRow: {
      type: Boolean,
      default: false
    },
    rowClassName: {
      type: Function,
      default () {
        return ''
      }
    },
    context: {
      type: Object
    },
    noDataText: {
      type: String
    },
    noFilteredDataText: {
      type: String
    },
    disabledHover: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * @description 全局设置是否可编辑
     */
    editable: {
      type: Boolean,
      default: false
    },
    /**
     * @description 是否可搜索
     */
    searchable: {
      type: Boolean,
      default: false
    },
    searchDefaultKey: {
      type:String,
        default:null,
    },
    /**
     * @description 搜索控件所在位置，'top' / 'bottom'
     */
    searchPlace: {
      type: String,
      default: 'top'
    },
    /**
     * @description 是否分页
     * */
    pageable: {
        type: Boolean,
        default: false
    },
      /**
       * @description 分页控件所在位置
      * */
    pagePlace: {
        type: String,
        default:'bottom'
    },
    exportable:{
      type: Boolean,
      default: false,
    },
    exportPlace: {
      type: String,
      default: 'top'
    },
    downTemp:{
      type:Boolean,
      default:true,
    },
      downpath:{
        type: String,
          default: ''
      },
    simple: {
        type: Boolean
    },
    preText: {
        type: String
    },
    nextText: {
        type: String
    },
    pageSizeOpts: {
        type: Array
    },
    placement: {
        type: String,
        default: 'bottom'
    },
    showSizer: {
        type: Boolean,
        default: false
    },
    className: {
        type: String,
        default: ''
    },
    pageStyle:{
        type:Object,
        default: null
    },
    psize:String,
    pageSize: {
        type: Number,
        default:10
    },
    showElevator: {
        type: Boolean,
        default: false
    },
    transfer: {
        type: Boolean,
        default: false
    },
    showTotal: {
        type: Boolean,
        default: false,
    },
    /**
     * @description 导入文件权限
    * */
    hasImportFileRole: {
        type: Boolean,
        default: false,
    },
        /**
     * @description 导出文件权限
    * */
    hasExportFileRole: {
        type: Boolean,
        default: false,
    },
    /**
     * @description 重新搜索
    * */
    reSearch: {
        type: Boolean,
        default: false,
    },
    dataTotal: {
      type: Number,
    },
    typeName:{
      type: String,
      default: ''
    }
  },
  /**
   * Events
   * @on-start-edit 返回值 {Object} ：同iview中render函数中的params对象 { row, index, column }
   * @on-cancel-edit 返回值 {Object} 同上
   * @on-save-edit 返回值 {Object} ：除上面三个参数外，还有一个value: 修改后的数据
   */
  data () {
    return {
      insideColumns: [],
      insideTableData: [],
      tempTableData: [],//临时查找数组
      allTableData: [],
      edittingCellId: '',
      edittingText: '',
      searchValue: '',
      searchKey: '',
      keyFull:false,
      total:0,
      current: 1,
      selections: [],
      exportLoading: false,
      showTime:false,//是否显示带有时间的搜索
      searchTime:[new Date(this.dateToString(new Date())+" 00:00:00") ,new Date(this.dateToString(new Date())+" 23:59:59")],
      pageSizeList:[10,20,50,100],
      speedChangePage:1,
      pageLimit:10,
      closeSearch:closeSearch,
      openSearch:openSearch,
      showPanel:false,
      addColumns:[],//字段列表集合
      leftOverColumns:[],//剩余未添加列的集合
      isSelectData:{},
      showCompare:false,
      showSelect:false,
      compareValue:'',
      isAddedKeys:[],//已添加的key
      isRefresh:[],//放置整个页面的搜索条件，用于判断页面是否变化
      searchStyle:{left:'', top:''},
      editingValues:{},
    }
  },
  methods: {
    //广播任务点击任务名称触发
    onCellClick(row, column, data, event){
      if(column.key == "broad_name" || column.key == "name"){
        this.$emit("on-cell-click",row)
      }
    },
    addDataToSearch(){
      if(this.leftOverColumns.length > 0){
        let ele = this.leftOverColumns[0]
        ele.value = ''
        this.addColumns.push(ele);
        this.isAddedKeys.push(ele.key);
        this.leftOverColumns.splice(0,1);
      }
    },
    deleteColumn(index){
      let ele = this.addColumns[index];
      ele.value = ''
      this.leftOverColumns.push(ele)
      let indexOne = this.isAddedKeys.findIndex(item=> item == ele.key);
      this.isAddedKeys.splice(indexOne,1);
      this.addColumns.splice(index,1);
    },
    closeSearchPanel(){
      this.showPanel = false;
    },
    updateSearchPanelPosition () {
      // 对齐表格左上角（表头顶边 + 左边缘），避免挡住标题行
      const applyPos = () => {
        const containerEl = this.$el
        if (!containerEl) return
        const tableEl =
          containerEl.querySelector('.ivu-table-wrapper') ||
          containerEl.querySelector('.ivu-table')
        const panelEl = containerEl.querySelector('.search-table')
        let left = 0
        let top = 0
        if (tableEl) {
          const containerRect = containerEl.getBoundingClientRect()
          const tableRect = tableEl.getBoundingClientRect()
          left = Math.round(tableRect.left - containerRect.left)
          top = Math.round(tableRect.top - containerRect.top)
        }
        left = Math.max(0, left)
        top = Math.max(0, top)
        this.searchStyle = {
          left: `${left}px`,
          top: `${top}px`,
          marginLeft: '0'
        }
        if (panelEl) {
          panelEl.style.setProperty('left', `${left}px`, 'important')
          panelEl.style.setProperty('top', `${top}px`, 'important')
          panelEl.style.setProperty('margin-left', '0', 'important')
        }
      }
      this.$nextTick(() => {
        applyPos()
        requestAnimationFrame(applyPos)
      })
    },
    showTablePanel(){
      if(this.addColumns.length == 0){
        this.leftOverColumns = JSON.parse(JSON.stringify(this.searchColumns));
        this.leftOverColumns.splice(this.isSelectData);
        this.addColumns.push(this.isSelectData);
        this.isAddedKeys.push(this.isSelectData.key);
      }else if(this.isSelectData && this.isSelectData.length > 0){
        this.addColumns[0] = this.isSelectData;
      }
      if(this.showPanel){
        this.showPanel = false;
      }else{
        this.showPanel = true;
        this.$nextTick(() => {
          this.updateSearchPanelPosition()
        })
      }

    },
    suportEdit (item, index) {
      item.render = (h, params) => {
        //const rowKey = params.row.id || params.row.initRowIndex
        const rowKey = params.row.rowUniqueId
        const cellKey = `${rowKey}-${params.column.key}`

        let originalValue;
        const rowInValue = this.value.find(item => item.rowUniqueId === rowKey);
        if (rowInValue) {
          originalValue = rowInValue[params.column.key];
        } else {
          originalValue = params.row[params.column.key]; // 降级方案
        }

        const editingValue = this.editingValues[cellKey] !== undefined
          ? this.editingValues[cellKey] : originalValue

        return h(TablesEdit, {
          props: {
            params: params,
            value: editingValue,
            edittingCellId: this.edittingCellId,
            editable: this.editable,
            rowKey: rowKey,
          },
          on: {
            'input': val => {
              this.editingValues[cellKey] = val;
              this.edittingText = val
            },
            'on-start-edit': (params,rowKey) => {
              const cellKey = `${rowKey}-${params.column.key}`;

              const rowInValue = this.value.find(item => item.rowUniqueId === rowKey);

              //this.edittingCellId = `editting-${params.index}-${params.column.key}`
              /*if (this.editingValues[cellKey] !== undefined) {
                this.editingValues[cellKey] = this.value[params.row.initRowIndex][params.column.key];
              }*/
              //this.edittingText = this.editingValues[cellKey];
              // 不再重置编辑值！
              this.edittingText = this.editingValues[cellKey] !== undefined
                ? this.editingValues[cellKey]
                : (rowInValue ? rowInValue[params.column.key] : params.row[params.column.key]);
              this.edittingCellId = `editting-${rowKey}-${params.column.key}`
              this.$emit('on-start-edit', params)
            },
            'on-cancel-edit': (params) => {
              const rowKey = params.row.rowUniqueId
              const cellKey = `${rowKey}-${params.column.key}`;
              delete this.editingValues[cellKey];
              this.edittingCellId = ''
              this.$emit('on-cancel-edit', params)
            },
            'on-save-edit': (params) => {
              const rowKey = params.row.rowUniqueId
              const cellKey = `${rowKey}-${params.column.key}`;

              this.value[params.row.initRowIndex][params.column.key] = this.editingValues[cellKey];
              delete this.editingValues[cellKey];

              this.$emit('input', this.value)
              this.$emit('on-save-edit', Object.assign(params, { value: this.edittingText }))
              this.edittingCellId = ''
            }
          }
        })
      }
      return item
    },
    surportHandle (item) {
      let options = item.options || []
      let insideBtns = []
      options.forEach(item => {
        if (handleBtns[item]) insideBtns.push(handleBtns[item])
      })
      let btns = item.button ? [].concat(insideBtns, item.button) : insideBtns
      item.render = (h, params) => {
        params.tableData = this.value
        return h('div', btns.map(item => item(h, params, this)))
      }
      return item
    },
    handleColumns (columns) {
      //过滤指定列
      columns = columns.filter((value,key,arr) => {
      return !value.hidden;     //内部走的就是value.hidden == false 成立吗，成立的部分返回，不成立的部分不返回。
      })
      this.insideColumns = columns.map((item, index) => {
        let res = item
        if (res.editable) res = this.suportEdit(res, index)
        if (res.key === 'handle') res = this.surportHandle(res)
        return res
      })
    },
    setDefaultSearchKey () {
      if(!this.searchColumns || this.searchColumns.length == 0){
        return;
      }
      let that = this;
      if(this.addColumns.length != 0){
        //判断整体搜索条件是否发生变化，变化则刷新搜索。
        if(that.searchColumns.sort().toString() == that.isRefresh.sort().toString()){
          return;
        }
        this.addColumns = [];
      }
      let spliceIndex = "";
      that.isAddedKeys = [];
      if (that.searchDefaultKey) {
        that.searchKey = that.searchDefaultKey;
        let index = that.searchColumns.findIndex(item=> item.key == that.searchDefaultKey);
        if(index != -1){
          that.addColumns.push(that.searchColumns[index]);
          that.isSelectData = that.searchColumns[index];
          that.isAddedKeys.push(that.searchColumns[index].key);
          spliceIndex = index;
        }
      } else {
        spliceIndex = 0;
        that.searchKey =  that.searchColumns[0].key;
        that.showTime = that.searchColumns[0].type === 'time';
        that.addColumns.push(that.searchColumns[0]);
        that.isSelectData = that.searchColumns[0];
        that.isAddedKeys.push(that.searchColumns[0].key);
      }
      that.isRefresh = JSON.parse(JSON.stringify(that.searchColumns));
      that.leftOverColumns = JSON.parse(JSON.stringify(that.searchColumns));
      if(spliceIndex != -1){
        that.leftOverColumns.splice(spliceIndex,1);
      }
    },
    changeSearchKey(key){
      let that = this;
      if (that.searchColumns.length > 0) {
        for (let i = 0; i < that.searchColumns.length; i++) {
          let ckey = that.searchColumns[i];
          if (ckey.key === key) {
            //把已选中的列加进去，把之前的列去除。
            if(that.isAddedKeys.length>0){
              let indexOne = that.isAddedKeys.findIndex(item=> item == that.isSelectData.key);
              if(indexOne != -1){
                that.isAddedKeys.splice(indexOne,1);
              }
            }
            that.isAddedKeys.push(ckey.key);
            that.isSelectData = ckey;
            //判断当前的列是否是时间类型
            that.showTime = ckey.type === 'time';
            that.showCompare = ckey.type === 'compare';
            that.showSelect = ckey.type === 'select';
            //刷新已剩余的列
            let index = that.leftOverColumns.findIndex(item=> item.key == ckey.key);
            if(index != -1){
              that.leftOverColumns.splice(index,1);
            }
            //把列表第一列重置
            if(that.addColumns.length>0){
              //再把之前删除的放进去待添加列表中
              that.leftOverColumns.push(that.addColumns[0]);
              that.addColumns[0] = ckey;
              return;
            }
            that.addColumns[0].push(ckey);
          }
        }
      }
    },
    changePanelKey(item,index){
      let that = this;
      let key = item.key;
      if (that.searchColumns.length > 0) {
        for (let i = 0; i < that.searchColumns.length; i++) {
          let ckey = that.searchColumns[i];
          if (ckey.key === key) {
            //select会将原数据结构的key替换调，这里根据oldKey判断，把之前的列去除。
            if(that.isAddedKeys.length>0){
              let indexOne = that.isAddedKeys.findIndex(item=> item == that.addColumns[index].oldKey);
              if(indexOne != -1){
                that.isAddedKeys.splice(indexOne,1);
              }
            }
            //把已选中的列加进去，
            if(ckey.key && that.isAddedKeys.indexOf(ckey.key) == -1){
              that.isAddedKeys.push(ckey.key);
            }
            //刷新已剩余的列
            let indexTwo = that.leftOverColumns.findIndex(item=> item.key == ckey.key);
            if(indexTwo != -1){
              that.leftOverColumns.splice(indexTwo,1);
            }

            //把列表第一列重置
            if(that.addColumns.length>0){
              //再把之前删除的放进去待添加列表中
              let param = JSON.parse(JSON.stringify(that.addColumns[index]));
              param.key = that.addColumns[index].oldKey;
              param.value = that.addColumns[index].value;
              that.leftOverColumns.push(param);

              that.addColumns[index].value = ckey.value;
              that.addColumns[index].oldKey = ckey.oldKey;
              that.addColumns[index].key = ckey.key;
              that.addColumns[index].type = ckey.type;
              that.addColumns[index].title = ckey.title;
              that.addColumns[index].list = ckey.list;
              return;
            }
            let param = that.addColumns[index];
            param.key = ckey.key;
            param.type = ckey.type;
            that.addColumns[index] = param;
          }
        }
      }
    },
    handleClear2(e){
      this.searchTime = [];
      this.handleSearch();
    },
    handleClear (e) {
      // if (e.target.value === ''){
      //   this.insideTableData = this.value
      //   this.tempTableData = JSON.parse(JSON.stringify(this.insideTableData));
      // }
      //   this.allTableData = [].concat(this.insideTableData)
      //   if (this.pageable && e.target.value === ''){
      //       this.total = this.insideTableData.length
      //
      //       if (this.total > this.pageSize) {
      //           this.insideTableData = this.insideTableData.slice(0,this.pageSize)
      //       }
      //       this.current = 1
      //   }
    },
    dateToString(val){
              var date = new Date(val)
              var y = date.getFullYear()
              var m = date.getMonth() + 1
              m = m < 10 ? ('0' + m) : m
              var d = date.getDate()
              d = d < 10 ? ('0' + d) : d
              const time = y + '-' + m + '-' + d
              return time;
    },
    handleSearch() {
      this.showPanel = false;
      let param = {};
      for (let i = 0; i < this.addColumns.length; i++) {
        param[this.addColumns[i].key] = this.addColumns[i].value;
        if("compare" === this.addColumns[i].type){
          param['compare'+this.addColumns[i].key] = this.addColumns[i].compare;
        }
      }
      this.$emit('changePageIndex',param,this.current,this.pageLimit)
    },
    handleTableData() {
      this.insideTableData = this.value.map((item, index) => {
        let res = item
        res.initRowIndex = index

        if (!res.rowUniqueId) {
          res.rowUniqueId = `row-${Date.now()}-${Math.random().toString(36).substring(2,9)}`
        }
        return res;
      })
      this.allTableData = [].concat(this.insideTableData)
      this.tempTableData = [].concat(this.insideTableData)

      let pageCount=Math.ceil(this.dataTotal/this.pageLimit);
      if(this.current>pageCount && this.current != 1){
        this.pageChange(1);
      }
      // if (this.pageable) {
      //   this.total = this.insideTableData.length
      //   if (this.total > this.pageSize) {
      //     this.insideTableData = this.insideTableData.slice(0, this.pageSize)
      //   }
      //   this.current = 1
      // }
    },
    exportCsv (params) {
      this.$refs.tablesMain.exportCsv(params)
    },
    clearCurrentRow () {
      this.$refs.tablesMain.clearCurrentRow()
    },
    toggleSelect(_index,rowKey){
      this.$refs.tablesMain.toggleSelect(_index, rowKey)
    },
    parentTable() {
      return this.$refs.tablesMain
    },
    onCurrentChange (currentRow, oldCurrentRow) {
      this.$emit('on-current-change', currentRow, oldCurrentRow)
    },
    onSelect (selection, row) {
      this.$emit('on-select', selection, row)
    },
    onSelectCancel (selection, row) {
      this.$emit('on-select-cancel', selection, row)
    },
    onSelectAll (selection) {
      this.$emit('on-select-all', selection)
    },
    onSelectAllCancel(selection) {
      this.$emit('on-select-all-cancel',selection)
    },
    onSelectionChange (selection) {
      this.$emit('on-selection-change', selection)
        this.selections = selection
    },
    onSortChange (column, key, order) {
      this.$emit('on-sort-change', column, key, order)
    },
    onFilterChange (row) {
      this.$emit('on-filter-change', row)
    },
    onRowClick (row, index) {
      this.$emit('on-row-click', row, index)
    },
    onRowDblclick (row, index) {
      this.$emit('on-row-dblclick', row, index)
    },
    onExpand (row, status) {
      this.$emit('on-expand', row, status)
    },
    onChange(index){
        this.current = index
        let _start = ( index - 1 ) * this.pageSize
        let _end = index * this.pageSize
       if (this.searchable) {//提供搜索时，从搜索后的结果中取
          this.insideTableData = this.tempTableData.slice(_start,_end)
       }else{ //不提供搜索时
         this.insideTableData = this.value.slice(_start,_end)
       }
        this.$emit('on-change',index)
    },
    onPageSizeChange(index){
        let _start = ( this.current - 1 ) * index;
        let _end = this.page * index;
        this.insideTableData = this.value.slice(_start,_end)
        this.pageSize = index
        this.$emit('on-page-size-change',index)
    },
    exportExcel() {
      let data = this.allTableData
        if (this.selections != null && this.selections.length > 0) {
            data = this.selections
        }
      this.$emit('exportExcel',this.columns,data);
    },
    handleUpload(file) {
        this.$emit('importData', file)
        return false
    },
    handleFormatError(file) {
      this.$emit('handleFormatError',file)
    },
    handleMaxSize(file) {
      this.$emit('handleMaxSize',file)
    },
    downTemplate() {
      this.$emit('downTemplate',true)
        if (this.downpath === '') {
            return false
        }
    },
    handleCurrentPage:function(){
        if(!this.speedChangePage){
          this.speedChangePage=1;
        }
        let reg=/^[0-9]*$/;
        if(!reg.test(this.speedChangePage)){
          this.$Modal.info({
            title:this.$t('tips'),
            content:this.$t('only_number')
          });
          return false;
        }
        let pageCount=Math.ceil(this.dataTotal/this.pageLimit);
        if(this.speedChangePage>pageCount && this.speedChangePage != 1){
          this.$Message.info(this.$t('page_count_overflow'))
          this.speedChangePage=pageCount;
        }
        this.speedChangePage = parseInt(this.speedChangePage);
        if(this.speedChangePage==0){
          this.speedChangePage=1;
        }
        this.pageChange(this.speedChangePage);
      },
    pageChange(index){
      this.current = index
      this.handleSearch(index);
    },
    changeSize(event) {
      this.pageLimit=event;
      this.pageChange(1);
    },
    handleDateChange(dateRange, type) {
  if (dateRange && dateRange.length === 2) {

      const startDate = new Date(dateRange[0]);
      const endDate = new Date(dateRange[1]);
      if (type === 'date') {
        endDate.setHours(23, 59, 59, 999);
      }
      const formattedEndDate = this.formatDate(endDate);
      // 更新日期范围值
      this.addColumns[0].value = [this.formatDate(startDate), formattedEndDate];

  } else {
    // 处理清空的情况
    this.addColumns[0].value = dateRange;
  }
},

// 同样的逻辑应用于面板中的日期选择器
handlePanelDateChange(item, dateRange, type) {
  if (dateRange && dateRange.length === 2) {
    const startDate = new Date(dateRange[0]);
    const endDate = new Date(dateRange[1]);
    if (type === 'date') {
      endDate.setHours(23, 59, 59, 999);
    }
    const formattedEndDate = this.formatDate(endDate);
    item.value =[this.formatDate(startDate), formattedEndDate];
  } else {
    // 处理清空的情况
    item.value = dateRange;
  }
}
,
  formatDate(date) {
    if (!this.isValidDate(date)) {
      return ''
    }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
},
    isValidDate(date) {
      return date instanceof Date && !isNaN(date.getTime())
    },
  },
  computed: {
    compareList: function () {
      return [{'id':'>','name':this.$t('greater_than')},
        {'id':'=','name':this.$t('equal')},
        {'id':'<','name':this.$t('less_than')},
        {'id':'>=','name':this.$t('greater_than_or_equal')},
        {'id':'<=','name':this.$t('less_than_or_equal')}]
    },
    themeChange: function () {
      return this.$store.state.app.theme;
    },
  },
  watch: {
    themeChange:{
      handler(){
        this.closeSearch=closeSearchWhite;
        this.openSearch=openSearchWhite;
        if("white" == this.themeChange){
          this.closeSearch=closeSearch;
          this.openSearch=openSearch;
        }
        if (this.showPanel) {
          this.$nextTick(() => {
            this.updateSearchPanelPosition()
          })
        }
      },
      immediate:true
    },
    columns (columns) {
      this.handleColumns(columns)
      this.setDefaultSearchKey()
    },
    value (val) {
      this.handleTableData()
      // if (this.searchable) this.handleSearch()
    },
    reSearch: {
      handler(newV, oldV){
      if(newV){
        // if (this.searchable) this.handleSearch()
      }
      }

    },
  },
  mounted () {
    this.handleColumns(this.columns)
    this.setDefaultSearchKey()
    this.handleTableData()
  }
}
</script>
<style scoped>
/deep/ .ivu-spin-fix {
  background-color: rgb(14 52 65 / 60%) !important;
}
</style>
<!-- 弹窗表格：隐藏 iView 误判溢出时的常驻横向滚动条 -->
<style lang="less">
.box-modal .custom-table .ivu-table-body,
.box-modal .custom-table .ivu-table-header,
.box-modal .custom-table .ivu-table-overflowX,
.ivu-modal .custom-table .ivu-table-body,
.ivu-modal .custom-table .ivu-table-header,
.ivu-modal .custom-table .ivu-table-overflowX {
  overflow-x: hidden !important;
}
.box-modal .custom-table .ivu-table-body::-webkit-scrollbar,
.ivu-modal .custom-table .ivu-table-body::-webkit-scrollbar {
  height: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tables/tables.vue